<script lang="ts" context="module">
  
  function mapItem(item: Record<string, unknown>): Item {
    const mapped = Object.assign({}, item); 
    mapped.name = item.name || item.display_name;
    mapped.deal_badge = item.badge || item.deal_badge;
    return mapped as Item;
  }

  export type Item = {
    // campaign_uuid: string;
    slug: string;
    name: string;
    //variant_name: string;
    price: number;
    old_price: number;
    restaurant_id: number;
    image_url: string;

    badge: string;
    deal_badge: string;
    // deals_applied: string[];
    collect_only: boolean;
    //
    restaurant: { dynamic: RestaurantDynamic, semi_static: RestaurantSemiStatic };
  };

  export type FoodItem = Item;
  export type ShopItem = Item;

  export const hasImg = (i: Item): boolean => truthy(i.image_url);

  export const online = (i: Item): boolean => i.restaurant.dynamic.online === true && i.restaurant.dynamic.open === true;
  export const offline = (i: Item): boolean => i.restaurant.dynamic.online === false || i.restaurant.dynamic.open === false;

  export const inStock = (i: Item): boolean => true; // i.visibility_status === "visible";
  export const outStock = (i: Item): boolean => false; // i.visibility_status === "sold_out";

  export const available = (i: Item): boolean => online(i) && inStock(i);
  export const unavailable = (i: Item): boolean => offline(i) || outStock(i);

  export const collectOnly = (i: Item): boolean => i.collect_only === true;

  export const deal = (i: Item): boolean => truthy(i.badge); // i.deal_badge !== null;

  // const halaal = (o: Item): boolean => i.restaurant.tag_string === "Halaal";
  export const hasFoodTag = (i: Item): boolean => false; // ["Halaal", "Kosher"].includes(i.restaurant.tag_string);

  export const distance = (i: Item): number => Number((i.restaurant.dynamic.distance / 1000).toFixed(1));
  export const preptime = (i: Item): number => i.restaurant.dynamic.prep_time + i.restaurant.dynamic.estimated_delivery_time_for_distance;

  export function availability(o: Item): string {
    if (offline(o)) return "Offline";
    if (outStock(o)) return "Sold out";
    if (collectOnly(o)) return "Collect only";
    const t = preptime(o);
    return `${t}min`;
  }
</script>

<script lang="ts">
  import type {RestaurantDynamic, RestaurantSemiStatic} from "$lib/def/landing";
  import LazyBackgroundImage from "$lib/ui/shared/LazyBackgroundImage.svelte";
  import {formatCurrency} from "$lib/util/format";
  import {truthy} from "$lib/util/func";

  export let item: Item
  $: mapped = mapItem(item);
</script>

{#if hasImg(mapped)}
  <button on:click class="item" class:unavailable={unavailable(mapped)}>
    <!--<span>{mapped.offers.length}</span>-->
    <LazyBackgroundImage image={[mapped.image_url, 200]} alt={mapped.name}>
      {#if unavailable(mapped)}
  	    <article class="cover"/>
      {/if}
      {#if deal(mapped)}
        <div class="promo-pill"><span class="label-s bold m-0">{mapped.badge}</span></div>
      {/if}
  	  <span class="availability-pill label-xs bold">{availability(mapped)}</span>
    </LazyBackgroundImage>
	  {#if mapped.old_price}
	  	<div class="wasnow">
	  		<span style="margin-right: 8px;" class="label-l bold m-0">{formatCurrency(Number(mapped.price))}</span>
	  		<span class="label-l medium m-0 medium-importance"><s>{formatCurrency(Number(mapped.old_price))}</s></span>
	  	</div>
	  	{:else}
	  	<div><span class="label-l bold m-0">{formatCurrency(Number(mapped.price))}</span></div>
	  {/if}
    <!--{#if deal(mapped)}
      <div class="label-xs bold m-0 color-promo">{mapped.badge}</div>
    {/if}-->
  	<div class="label-m book m-0 mt-6px cut-text">{mapped.name}</div>
  	<div class="label-s bold ellipses m-0 mt-4px">{mapped.restaurant.semi_static.name}</div>
    {#if hasFoodTag(mapped)}
  	  <div class="label-s book m-0 ">{mapped.restaurant.dynamic.tag_string}</div>
    {/if}
  </button>
{/if}

<!-- NO IMAGE -->
{#if !hasImg(mapped)}
  <button on:click class="item no-image" class:unavailable={unavailable(mapped)}>
    <!--<span>{mapped.offers.length}</span>-->
    <div class="lebel-l bold">{formatCurrency(Number(mapped.price))}</div>
    {#if deal(mapped)}
      <div class="label-xs bold m-0 color-promo">{mapped.deal_badge}</div>
    {/if}
  	<div class="label-m book m-0 mt-6px">{mapped.name}</div>
    <div class="label-s bold ellipses m-0 mt-4px">{mapped.restaurant.semi_static.name}</div>
    {#if hasFoodTag(mapped)}
  	  <div class="label-s book m-0 ">{mapped.restaurant.dynamic.tag_string}</div>
    {/if}
  	<div style="margin-top: 12px;"><span class="availability-pill label-xs bold">{availability(mapped)}</span></div>
  </button>
{/if}



<style lang="scss">
  @use "screen";
  @use "color";

  button {
    text-align: left;
  }

  .cut-text {
    max-height: 65px;
    white-space: break-spaces;
	  overflow: hidden;
	  text-overflow: ellipsis;
  }

  .mt-6px {
    margin-top: 6px !important;
  }

  .mt-4px {
    margin-top: 4px !important;
  }

  .color-promo {
    color: color.$promo;
  }

	.cover {
    border-radius: inherit;
		position: absolute;
    top: 0;
    left: 0;
		width: 100%;
		height: 100%;
		background-color: color.transparent(0.7);
		z-index: 2;
	}

  // added :global() to remove 'npm run check' warnings
  :global(.item), .offer {
    &.unavailable {
      color: color.$on-background-low-importance;
      .color-promo {
        color: color.$on-background-low-importance;
      }
    }
  }


  .item:not(.no-image) {
    .availability-pill {
      position: absolute;
      bottom: 5px;
      left: 5px;
    }
  }

  .item:is(.no-image) {
    border: 2px solid color.$separator;
    border-radius: 25px;
    padding: 15px;

    &:hover {
      border: 2px solid color.$on-background-high-importance;
    }
  }

  .promo-pill {
    position: absolute;
    top: 3px;
    left: 3px;

    background-color: color.$promo;
    padding: 2px 5px;
    border-radius: 20px;
    z-index: 2;
  }

  .availability-pill {
    background-color: color.$white;
    color: color.$black;
    border: 1px solid color.$separator;
    border-radius: 10px;
    padding: 2px 5px;
    z-index: 2;
  }
</style>
